<app-modal-filler-atom
  (click)="close()"
  [index]="index$ | async"
></app-modal-filler-atom>
<div
  class="fixed right-0 left-0 shadow overflow-y-auto mdMax:bottom-0 mdMax:max-h-85-screen mdMax:max-w-screen-sm mdMax:mx-auto md:flex md:justify-center md:items-center md:w-full md:h-full md:top-0 md:left-0"
  [style.z-index]="(index$ | async) + 50"
>
  <app-modal-filler-atom
    *ngIf="isDesktop$ | async"
    [withBackdrop]="false"
    (click)="close()"
    [index]="index$ | async"
  ></app-modal-filler-atom>
  <div
    class="bg-white p-5 md:p-7 rounded-t-3xl md:rounded-3xl md:max-w-lg flex flex-col"
    [style.z-index]="(index$ | async) + 50"
  >
    <div class="flex justify-between items-center pb-5">
      <h1
        class="text-neutral-800 font-brand font-bold text-28px"
        p
        translate="zerosix.loyalty-program"
      ></h1>
      <a
        class="cursor-pointer"
        (click)="close()"
        ><i class="icon icon-cross"></i
      ></a>
    </div>
    <ng-container *ngIf="!this.isLoading && !this.accountExists">
      <div class="pb-7">
        <p class="text-neutral-800 font-base text-base pb-3">
          {{ 'zerosix.want-to-join-loyalty-program' | translate }}
        </p>
        <app-button-atom
          [type]="'primary'"
          [label]="'zerosix.create-loyalty-account' | translate"
          [size]="'L'"
          (click)="openCreateLoyaltyAccountModal()"
        ></app-button-atom>
      </div>
      <div class="pb-6">
        <p class="text-neutral-800 font-base text-base pb-3">
          {{ 'zerosix.already-member' | translate }}
        </p>
        <app-button-atom
          [type]="'primary'"
          [label]="'zerosix.connect-with-loyalty-account' | translate"
          [size]="'L'"
          (click)="openLinkWithLoyaltyAccountModal()"
        ></app-button-atom>
      </div>
      <div class="flex pb-8 items-center">
        <div class="w-full h-px border border-neutral-400"></div>
        <span class="inline-block px-3 font-base font-bold text-base text-neutral-500">{{
          'divider.or' | translate
        }}</span>
        <div class="w-full h-px border border-neutral-400"></div>
      </div>
      <div class="pb-3">
        <app-button-atom
          [type]="'light'"
          [label]="'zerosix.continue-without-loyalty-account' | translate"
          [size]="'L'"
          (click)="close()"
        ></app-button-atom>
      </div>
    </ng-container>
    <ng-container *ngIf="!this.isLoading && this.accountExists">
      <div class="pb-7">
        <p class="text-neutral-800 font-base text-base pb-3">
          {{ 'zerosix.already-member-information' | translate }}
        </p>
      </div>
      <div class="pb-3">
        <app-button-atom
          [type]="'light'"
          [label]="'zerosix.cancel' | translate"
          [size]="'L'"
          (click)="close()"
        ></app-button-atom>
      </div>
    </ng-container>
    <ng-container *ngIf="this.isLoading">
      <div class="flex flex-row items-center justify-center h-48 w-full">
        <img
          src="assets/images/spinner.svg"
          class="pr-4"
        />
      </div>
    </ng-container>
  </div>
</div>
